import InvoiceProductTable from '.';

const InvoiceTableHeader = ({
	tableError,
	setTableError,
	invoiceTable,
	isDraft,
	setInvoiceTable,
	productsList,
}) => {
	const columns = [
		{ name: 'product_id', label: 'Product Name', type: 'product_name' },
		{ name: 'batch_no', label: 'Batch Number', type: 'batch_no' },
		{ name: 'expiry_date', label: 'Expiry', type: 'date' },
		{ name: 'mrp', label: 'MRP', type: 'text' },
		{ name: 'quantity', label: 'QTY', type: 'text' },
		{ name: 'amount', label: 'Amount', type: 'text' },
	];

	const initialRows = [
		{
			product_id: '',
			batch_no: '',
			expiry_date: '',
			mrp: '0.00',
			quantity: '',
			amount: '0.00',
			product_batch_id: null,
			tag: null,
			product_tax1: 0,
			product_tax2: 0,
		},
	];
	return (
		<div
			className="max-w-1297"
			style={{ paddingBottom: '160px' }}
		>
			<InvoiceProductTable
				isDraft={isDraft}
				productsList={productsList}
				initialRows={initialRows}
				columns={columns}
				tableError={tableError}
				setTableError={setTableError}
				invoiceTable={invoiceTable}
				setInvoiceTable={setInvoiceTable}
			/>
		</div>
	);
};
export default InvoiceTableHeader;
